import React from 'react';
import { Card } from 'antd';
import {
  Button,
  Body,
  Icon,
  Colors,
  Select,
  Flex,
  OptionType,
} from '@cognite/cogs.js';
import styled from 'styled-components/macro';
import mixpanel from 'utils/mixpanel-frontend';
import { ProjectListItem } from 'hooks/projects';
import { getVersionSelectOptions } from '../helpers';

export const SolutionCard = ({
  project,
  active,
  selectedVersion,
  onHandleProjectChange,
}: {
  project: ProjectListItem;
  active: boolean;
  selectedVersion?: string;
  onHandleProjectChange: (
    project: ProjectListItem,
    state: boolean,
    version?: string
  ) => void;
}) => {
  const handleSelectProject = (
    version = selectedVersion,
    selected = active
  ) => {
    if (!version && !!project.versions.length) {
      version = project.versions[project.versions.length - 1]?.version;
    }
    onHandleProjectChange(project, selected, version);
  };
  return (
    <>
      <StyledCard active={active} key={project?.id}>
        <FlexContainer>
          <FlexContainer>
            <Body level={1}>{`${project.name}`}</Body>
          </FlexContainer>
          <Flex gap={5}>
            {active && (
              <SelectVersionContainer>
                <Select
                  placeholderSelectText="Schema versions"
                  disableTyping
                  value={
                    selectedVersion
                      ? {
                          label: `v. ${selectedVersion}`,
                          value: selectedVersion,
                        }
                      : { label: 'Select Version' }
                  }
                  options={getVersionSelectOptions(project.versions)}
                  onChange={({ value }: OptionType<string>) =>
                    handleSelectProject(value, active)
                  }
                />
              </SelectVersionContainer>
            )}
            <StyledButton
              onClick={() => {
                handleSelectProject(selectedVersion, !active);
                mixpanel.track('Select schema', {
                  id: project?.id,
                  name: project?.name,
                });
              }}
              type={active ? 'primary' : 'tertiary'}
            >
              {active ? (
                <StyledDiv>
                  <Icon style={{ marginRight: '0.5rem' }} type="Checkmark" />{' '}
                  Selected
                </StyledDiv>
              ) : (
                'Select'
              )}
            </StyledButton>
          </Flex>
        </FlexContainer>
      </StyledCard>
    </>
  );
};

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledButton = styled(Button)``;

const StyledCard = styled(Card)<{ active: boolean }>`
  margin-top: 8px;
  min-width: 380px;
  width: 100%;
  align: left;
  border-radius: 5px;
  border-color: var(--cogs-greyscale-grey2);
  box-shadow: var(--cogs-z-4);
  ${({ active }: any) =>
    active &&
    `
    border: solid 1px var(--cogs-midblue-3);
    background: var(--cogs-midblue-7);
  `}
`;

const SelectVersionContainer = styled.div`
  min-width: 150px;
`;
